import "./app.less";
import "./index.d";
import React, { lazy, Suspense, useState } from "react";
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';
import { GlobalDataProvider } from './stores/provider';
const router = createBrowserRouter(routes);
function App() {
  return (
    <GlobalDataProvider>
    <RouterProvider router={router}/>
    </GlobalDataProvider>
  );
}

export default App;
